import React from 'react';
import { Zoom } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

export const _Home1 = () => {
    const heroSlides = [
        {
            image: "/img/1.jpg",
            eyebrow: "Studio multimedia",
        },
        {
            image: "/img/2.jpg",
            eyebrow: "Evenementiel & reportage",
        },
        {
            image: "/img/3.jpg",
            eyebrow: "Communication digitale",
        },
    ];

    const slideOptions = {
        scale: 0.1,
        duration: 3000,
        transitionDuration: 2000,
        infinite: true,
        indicators: false,
        arrows: false,
        autoplay: true,
        pauseOnHover: true,
        canSwipe: true,
    };

    return (
        <section id="hero" className="hero dashboard-hero dashboard-hero--editorial">
            <Zoom {...slideOptions}>
                {heroSlides.map((slide, index) => (
                    <div className="dashboard-hero__scene" key={slide.image}>
                        <img src={slide.image} alt={slide.eyebrow} className="dashboard-hero__image" />
                    </div>
                ))}
            </Zoom>
        </section>
    );
}
